import { ScrollContainer } from './scroll-container'

export default ScrollContainer
